import { RateCard, toast, Loader } from '@components';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLaneRateCardsHistory } from '@api';
import { RateCardHistory } from '@types';
import { useWithImpersonation } from '@hooks';

type TProps = {
	type: 'Shipper'|'Carrier'|'Admin';
}

type impersonationRole = 'shipper' | 'carrier';

export const HistoricalRateCard = (Props: TProps) => {
	const { isLoadingGetLane, callGetHistory } = useLaneRateCardsHistory();
	const [laneHistory, setLaneHistory] = useState<RateCardHistory>();
	const [searchParams,] = useSearchParams();
	const params = useParams();
	const laneData = params.id ?? null;
	const navigate = useNavigate();
	const requestedRevision = searchParams.get('version');
	const isLinkedRateCard = searchParams.get('isLinkedRateCard') === 'true';
	const [currentVersion, setCurrentVersion] = useState<string | null>(requestedRevision);
	const { type } = Props
	const location = useLocation();
	const dynamicType = type === 'Admin' ? 'shipper' : type.toLowerCase();
	const withImpersonation = useWithImpersonation(dynamicType as impersonationRole)

	const backToLiveVersion = () => {
		const [basePath] = location.pathname.split(/\/history\/?/);
		const url = `${basePath || '/'}?live=true`;
		if (isLinkedRateCard) {
			const externalId = basePath.split('/').pop();
			const url = `configuration/ratecards/linked/update/step2/${externalId}`
			navigate(withImpersonation(url));
			return;
		}

		navigate(withImpersonation(url));
	}

	useEffect(() => {
		if (!laneData) return;

		callGetHistory({ routes: [laneData] })
			.then((response) => {
				if (response?.data) {

					// Approved entries do not have a snapshot entry
					const entries = response?.data?.data?.filter(
						(entry) => entry.action.toLowerCase() !== 'approved');
					if (!entries || entries.length <= 1) {
						toast.error('No Revisions - navigating back');
						backToLiveVersion()
						return;
					}

					const isDeleted = entries[0]?.action?.toLowerCase() === 'deleted';
					const validEntries = isDeleted ? entries : entries.slice(1);

					setLaneHistory({
						...response.data,
						data: validEntries
					});

					if (!currentVersion) {
						setCurrentVersion(validEntries[0]?.external_id);
					}
				}
			})
			.catch(() => {
				toast.error('Error fetching lane history');
			});
	}, [laneData]);

	return (
		<>
			{isLoadingGetLane || !currentVersion ? (
				<Loader />
			) : (
				<RateCard
					settingType={type}
					readonly={true}
					history={laneHistory}
					version={currentVersion}
					isLinkedRateCard={isLinkedRateCard}
					backToLiveVersion={backToLiveVersion}
				/>
			)}
		</>
	);

};